import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Authenticator } from "@aws-amplify/ui-react";
import { RootStoreProvider } from "./app/shared/stores/RootStore";
import "./i18n/i18n";
import "./index.css";
import { ChakraProvider, Portal } from "@chakra-ui/react";
import { system } from "./theme";
import "@fontsource-variable/montserrat";
import { CustomToaster } from "./app/shared/views/CustomToaster";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Authenticator.Provider>
    <RootStoreProvider>
      <ChakraProvider value={system}>
        <App />
        <Portal>
          <CustomToaster />
        </Portal>
      </ChakraProvider>
    </RootStoreProvider>
  </Authenticator.Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
